import { Box, Button, Menu, MenuItem, Typography } from '@mui/material'
import React, { useRef, useState } from 'react'
import { useOrganizationStore } from '../../store/organization.store'
import { Icons } from '../../utils/utilities'

const InstituteSelect = ( { disabled, handleInstituteChange, selectedInstitute, showAll = true, buttonStyles = {} } ) => {

    const [instituteSelectOpen, setInstituteSelectOpen] = useState( false )

    const instituteSelectRef = useRef()

    const OrganizationStore = useOrganizationStore()

    const handleSelect = val => {
        setInstituteSelectOpen( false )
        handleInstituteChange( val )
    }

    return (
        <Box>
            <Button size='small' disabled={disabled} onClick={() => setInstituteSelectOpen( true )} ref={instituteSelectRef} endIcon={Icons.default.KeyboardArrowDownIcon} variant='contained' disableElevation sx={{ height: "40px", background: `linear-gradient(125.39deg, #139CFF -32.54%, #C54097 110.4%)`, opacity: disabled ? 0.6 : 1, ...( buttonStyles || {} ), justifyContent: "space-between", '&:disabled': { pointerEvents: "all", cursor: disabled && "not-allowed !important", ...( buttonStyles?.disabled || {} ) }, }} >
                <Typography minWidth="60px" textAlign="left" variant='subtitle2' color={disabled ? buttonStyles?.disabled?.color || "lightgray" : buttonStyles?.color || "white"}>{( selectedInstitute === "all" || !selectedInstitute ) ? "Institute" : selectedInstitute}</Typography>
            </Button>
            <Menu slotProps={{ paper: { sx: { marginTop: "5px", maxHeight: "250px" } } }} anchorEl={instituteSelectRef.current} open={instituteSelectOpen} onClose={() => setInstituteSelectOpen( false )}>
                {showAll && <MenuItem onClick={() => handleSelect( "all" )} dense sx={{ fontSize: "12px" }} value="all">All</MenuItem>}
                {
                    OrganizationStore.getOrganization.map( ( obj, i ) => {
                        return <MenuItem dense onClick={() => handleSelect( obj.institute_name_short )} sx={{ fontSize: "12px", textTransform: "capitalize" }} value={obj.institute_name_short} key={'key-' + i}> <strong>{obj.institute_name_short}</strong> - {obj.institute_name?.toLowerCase()}  </MenuItem>
                    } )
                }
            </Menu>
        </Box >
    )
}

export default InstituteSelect
